export const formQuestions = [
  {
    id: 0,
    header: { fr: "Bug", en: "Bug" },
    title: { fr: "Signaler un bug", en: "Report a Bug" },
    issueDisplay: { fr: "Rapport de bug", en: "Bug Report" },
    issueID: "10004",
    issueType: "Bug",
    questions: {
      bugQuestion1: {
        text: {
          fr: "Quel client est concerné ?",
          en: "Which client was this related to?",
        },
        type: "text",
      },
      bugQuestion2: {
        text: {
          fr: "Décrivez ce que vous essayiez de faire",
          en: "Describe what you were trying to do",
        },
        type: "textarea",
        textAreaMinHeight: "16vh",
      },
      bugQuestion3: {
        text: {
          fr: "Décrivez ce qui s'est passé lorsque vous avez essayé",
          en: "Describe what happened when you tried",
        },
        type: "textarea",
        textAreaMinHeight: "12vh",
      },
      bugQuestion4: {
        text: {
          fr: "Si vous avez reçu un message d'erreur, que disait-il ?",
          en: "If you received an error message, what did it say?",
        },
        type: "textarea",
        textAreaMinHeight: "8vh",
      },
    },
  },
  {
    id: 1,
    header: { fr: "Demande de fonctionnalité", en: "Feature Request" },
    title: { fr: "Demander une fonctionnalité", en: "Request a Feature" },
    issueDisplay: { fr: "Demande de fonctionnalité", en: "Feature Request" },
    issueID: "10005",
    issueType: "Feature Request",
    questions: {
      featureQuestion1: {
        text: {
          fr: "Veuillez décrire la nouvelle fonctionnalité que vous souhaitez ajouter en détail, par exemple dans quelles circonstances pouvez-vous l'utiliser, que fait-elle, etc. ?",
          en: "Please describe the new feature you would like to add in as much detail as possible, i.e. in what circumstances can you use it, what does it do etc?",
        },
        type: "textarea",
        textAreaMinHeight: "20vh",
      },
    },
  },
  {
    id: 2,
    header: { fr: "Demande d'opération", en: "Operation Request" },
    title: {
      fr: "Demander une opération supplémentaire",
      en: "Request an Additional Operation",
    },
    issueDisplay: { fr: "Demande d'opération", en: "Operation Request" },
    issueID: "10005",
    issueType: "Feature Request",
    questions: {
      operationQuestion1: {
        text: {
          fr: "Veuillez décrire l'opération que vous souhaitez ajouter",
          en: "Please describe the operation you would like to add",
        },
        type: "textarea",
        textAreaMinHeight: "16vh",
      },
    },
  },
  {
    id: 3,
    header: { fr: "Demander un nouvel assureur", en: "Request New Insurer" },
    title: {
      fr: "Demander un nouvel assureur",
      en: "Request an Additional Insurer",
    },
    issueDisplay: { fr: "Demande d'assureur", en: "Insurer Request" },
    issueID: "10006",
    issueType: "Insurer Request",
    questions: {
      insurerQuestion1: {
        text: {
          fr: "Quel nouvel assureur souhaitez-vous que nous ajoutions ?",
          en: "Which new insurer would you like us to add?",
        },
        type: "text",
      },
      insurerQuestion2: {
        text: {
          fr: "Êtes-vous prêt et capable de soutenir une introduction à quelqu'un de ce assureur à un niveau approprié pour faciliter une introduction ?",
          en: "Are you willing and able to support an introduction to someone at an appropriate level of seniority at this insurer to support an introduction?",
        },
        type: "radio",
      },
    },
  },
  {
    id: 4,
    header: { fr: "Ajouter une nouvelle question", en: "Add New Question" },
    title: {
      fr: "Demander une question supplémentaire",
      en: "Request an Additional Question",
    },
    issueDisplay: { fr: "Demande de question", en: "Question Request" },
    issueID: "10005",
    issueType: "Feature Request",
    questions: {
      questionQuestion1: {
        text: {
          fr: "Quelle est l'opération ou le type d'activité ?",
          en: "What is the operation or type of business?",
        },
        type: "text",
      },
      questionQuestion2: {
        text: {
          fr: "Quelles questions doivent être ajoutées ?",
          en: "What question(s) should be added?",
        },
        type: "textarea",
        textAreaMinHeight: "12vh",
      },
      questionQuestion3: {
        text: {
          fr: "Si la réponse nécessite une sélection d'options prédéfinies : quelles devraient-elles être ?",
          en: "If the answer requires a selection of predefined options: what should these be?",
        },
        type: "textarea",
        textAreaMinHeight: "16vh",
      },
      questionQuestion4: {
        text: {
          fr: "Dans quelle partie de l'application la question doit-elle se trouver ?",
          en: "In what part of the application should the question reside?",
        },
        type: "textarea",
        textAreaMinHeight: "8vh",
      },
    },
  },
];
